import React, { useState, useEffect, useCallback } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { useMenuStyles } from "../../components/menuStyles";
import { useAdminStyles, num, dateTime, since } from "./styles";

// Conversas do cliente (copiloto e chat).
//
// LISTAR não registra nada — é navegação. ABRIR registra na auditoria quem leu,
// de quem e quando: conversa de cliente é dado sensível, e sem esse registro
// não há como responder "quem viu isso?" depois. O aviso na tela existe para a
// equipe saber disso ANTES de abrir.
const TOM = {
  texto: {},
  ferramenta: { fontFamily: "monospace", opacity: 0.75 },
  resultado: { fontFamily: "monospace", opacity: 0.6 },
};

const UserConversations = ({ userId }) => {
  const classes = useAdminStyles();
  const menu = useMenuStyles();
  const [d, setD] = useState(null);
  const [aberta, setAberta] = useState(null);
  const [carregando, setCarregando] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/admin/users/${userId}/conversations`);
      setD(data);
    } catch (err) {
      toastError(err);
    }
  }, [userId]);

  useEffect(() => { load(); }, [load]);

  const abrir = async (tipo, id) => {
    setCarregando(true);
    try {
      const url = tipo === "copiloto" ? `/admin/copilot-transcripts/${id}` : `/admin/chat-conversations/${id}`;
      const { data } = await api.get(url);
      setAberta({ tipo, ...data });
    } catch (err) {
      toastError(err);
    } finally {
      setCarregando(false);
    }
  };

  if (!d) return null;
  const vazio = !d.copiloto.length && !d.chat.length;

  return (
    <div className={classes.card}>
      <div className={classes.cardTitle}>Conversas</div>
      <div className={classes.cardSub}>
        Abrir o conteúdo fica registrado na auditoria (quem leu, de quem, quando).
      </div>

      {vazio && <div className={classes.empty}>Nenhuma conversa registrada.</div>}

      {d.copiloto.map((c, i) => (
        <div key={`c${c.id}`} className={`${classes.row} ${i === 0 ? classes.rowFirst : ""}`}>
          <div className={classes.grow}>
            <div className={classes.strong}>Copiloto · {c.aplicacao}</div>
            <div className={classes.muted}>
              {num(c.turnos)} turno(s) · {num(c.tokensIn + c.tokensOut)} tokens · {since(c.lastMessageAt)}
              {c.model ? ` · ${c.model}` : ""}
            </div>
          </div>
          <Button size="small" disabled={carregando} onClick={() => abrir("copiloto", c.id)}>Ler</Button>
        </div>
      ))}

      {d.chat.map(c => (
        <div key={`h${c.id}`} className={classes.row}>
          <div className={classes.grow}>
            <div className={classes.strong}>Chat · {c.title}</div>
            <div className={classes.muted}>{num(c.mensagens)} mensagem(ns) · {since(c.updatedAt)}</div>
          </div>
          <Button size="small" disabled={carregando} onClick={() => abrir("chat", c.id)}>Ler</Button>
        </div>
      ))}

      <Dialog open={!!aberta} onClose={() => setAberta(null)} maxWidth="md" fullWidth PaperProps={{ className: menu.dialogPaper }}>
        <DialogTitle>
          {aberta && (aberta.tipo === "copiloto"
            ? `Copiloto · ${aberta.aplicacao ? aberta.aplicacao.name : "sem fluxo"}`
            : `Chat · ${aberta && aberta.title}`)}
        </DialogTitle>
        <DialogContent dividers>
          {aberta && aberta.mensagens.map((m, i) => (
            <div key={i} className={`${classes.row} ${i === 0 ? classes.rowFirst : ""}`} style={{ alignItems: "flex-start" }}>
              <div style={{ width: 92 }}>
                <span className={`${classes.pill} ${m.role === "user" ? classes.neutral : classes.ok}`}>
                  {m.role === "user" ? "cliente" : m.role === "assistant" ? "copiloto" : m.role}
                </span>
              </div>
              <div className={classes.grow}>
                {m.blocos.map((b, j) => (
                  <div key={j} className={classes.muted} style={{ ...TOM[b.tipo], whiteSpace: "pre-wrap", marginBottom: 4 }}>
                    {b.tipo !== "texto" ? `[${b.tipo}] ` : ""}{b.texto}
                  </div>
                ))}
                {m.createdAt ? <div className={classes.muted} style={{ fontSize: 11 }}>{dateTime(m.createdAt)}</div> : null}
              </div>
            </div>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAberta(null)}>Fechar</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UserConversations;
